package com.narbase.letsgo.web.views.admin.contactUs


import com.narbase.kunafa.core.components.*
import com.narbase.kunafa.core.components.layout.LinearLayout
import com.narbase.kunafa.core.css.*
import com.narbase.kunafa.core.dimensions.dependent.matchParent
import com.narbase.kunafa.core.dimensions.dependent.weightOf
import com.narbase.kunafa.core.dimensions.dependent.wrapContent
import com.narbase.kunafa.core.dimensions.dimen
import com.narbase.kunafa.core.dimensions.px
import com.narbase.kunafa.core.dimensions.vh
import com.narbase.kunafa.core.drawable.Color
import com.narbase.letsgo.dto.dto
import com.narbase.letsgo.dto.enum
import com.narbase.letsgo.web.common.AppColors
import com.narbase.letsgo.web.dto.config.ContactDto
import com.narbase.letsgo.web.models.ContactType
import com.narbase.letsgo.web.theme.theme
import com.narbase.letsgo.web.translations.localized
import com.narbase.letsgo.web.utils.animation.errorShake
import com.narbase.letsgo.web.utils.horizontalFiller
import com.narbase.letsgo.web.utils.string.splitCamelCase
import com.narbase.letsgo.web.utils.verticalFiller
import com.narbase.letsgo.web.utils.views.*
import com.narbase.letsgo.web.views.templates.EntriesStyles.textInputStyle

class UpsertContactDialog(private val onUpdated: () -> Unit) {
    private var dtoToEdit: ContactDto? = null
    private val popUp = popUpDialog { }

    private var errorTextView: TextView? = null
    private val viewModel = ContactUsManagementViewModel()

    private var typeDropDownList: DropDownList<ContactType>? = null
    private var imageContainer: LinearLayout? = null
    private var imageUploader: ImageUploader? = null
    private var nameTextInput: TextInput? = null
    private var addressTextInput: TextInput? = null
    private var externalLinkContainer: LinearLayout? = null
    private var externalLinkTextInput: TextInput? = null

    private fun upsertDialog() {
        viewModel.getConfig()
        theme.showDialog(popUp) { dialogBuilder ->
            verticalLayout {
                id = "upsertContactRootView"
                style {
                    height = wrapContent
                    minWidth = 800.px
                    width = matchParent
                    backgroundColor = Color.white
                    borderRadius = 8.px
                }
                horizontalLayout {
                    style {
                        width = matchParent
                    }
                    theme.bigTextView(this) {
                        text = if (dtoToEdit == null) "Add contact".localized() else "Edit contact".localized()
                    }
                    horizontalFiller()

                }
                verticalFiller(16)

                horizontalLayout {
                    style {
                        width = matchParent
                        maxHeight = 60.vh
                    }
                    verticalLayout {
                        style {
                            width = weightOf(1)
                            height = 60.vh
                        }
                        var inputsView: LinearLayout? = null
                        fun showInputs(contactType: ContactType?) {
                            contactType ?: return
                            inputsView?.apply {
                                clearAllChildren()

                                nameTextInput = theme.labeledTextInput(
                                    this, when (contactType) {
                                        ContactType.Phone -> "Name"
                                        ContactType.Email -> "Name"
                                        ContactType.Other -> "Title"
                                    }
                                        .localized(), isRequired = true
                                ) {
                                    text = dtoToEdit?.name ?: ""
                                }
                                addressTextInput =
                                    theme.labeledTextInput(
                                        this, when (contactType) {
                                            ContactType.Phone -> "Phone number"
                                            ContactType.Email -> "Address"
                                            ContactType.Other -> "Subtitle"
                                        }
                                            .localized(), isRequired = true
                                    ) {
                                        text = dtoToEdit?.address ?: ""
                                    }
                            }

                        }

                        theme.label(this, "Contact Type".localized(), isRequired = true)
                        typeDropDownList = setupDropDownList(
                            name = "Contact Type".localized(),
                            list = ContactType.values(),
                            itemToString = { it.name.splitCamelCase() },
                            defaultValue = dtoToEdit?.type?.enum(),
                            customRuleSet = classRuleSet { width = matchParent },
                            onItemSelected = {
                                showInputs(it)
                                if (it == ContactType.Other) {
                                    externalLinkContainer?.isVisible = true
                                    imageContainer?.isVisible = true
                                } else {
                                    externalLinkContainer?.isVisible = false
                                    imageContainer?.isVisible = false
                                }
                            }
                        )


                        inputsView = verticalLayout { style { width = matchParent } }
                        showInputs(dtoToEdit?.type?.enum())

                        imageContainer = verticalLayout {
                            style {
                                width = matchParent
                            }
                            theme.label(this, "Icon".localized(), isRequired = true)
                            imageUploader = imageUploader(defaultImageUrl = dtoToEdit?.imageUrl) {

                            }
                        }
                        externalLinkContainer = verticalLayout {
                            style {
                                width = matchParent
                            }
                            externalLinkTextInput =
                                theme.labeledTextInput(this, "External Link".localized(), isRequired = true) {
                                    text = dtoToEdit?.link ?: ""
                                }
                        }
                    }

                }

                verticalFiller(8.px)
                errorTextView = textView {
                    style {
                        marginBottom = 8.px
                        fontSize = 14.px
                        color = AppColors.redLight
                        padding = 20.px
                    }
                    isVisible = false
                }

                dialogBuilder.bottomBar = {
                    horizontalLayout {
                        style {
                            width = matchParent
                            height = wrapContent
                            justifyContent = JustifyContent.End
                        }
                        theme.unimportantButton(this) {
                            text = "Dismiss".localized()
                            onClick = {
                                popUp.dismissDialog()
                            }

                        }

                        horizontalFiller(16)

                        val saveButton = theme.mainButton(this) {
                            text = "Save".localized()
                            id = "SaveButton"
                            onClick = {
                                onSaveButtonClicked()
                            }
                        }
                        viewModel.upsertUiState.clearObservers()
                        saveButton.withLoadingAndError(viewModel.upsertUiState,
                            onRetryClicked = {
                                onSaveButtonClicked()
                            },
                            onLoaded = {
                                popUp.dismissDialog()
                                onUpdated()
                            }
                        )
                    }

                }
            }
        }

    }

    private fun onSaveButtonClicked() {
        val imageUrl = imageUploader?.imageUrl?.ifBlank { null }
        val name = nameTextInput?.validateAndGetText()
        val address = addressTextInput?.validateAndGetText()
        val link = externalLinkTextInput?.validateAndGetText()?.ifBlank { null }
        val type = typeDropDownList?.getSelectedItem()
        if (type == null) {
            typeDropDownList?.rootView?.errorShake()
            errorTextView?.text = "Please select contact type".localized()
            errorTextView?.isVisible = true
            isDataValid = false
            return
        }
        if (name.isNullOrBlank()) {
            nameTextInput?.errorShake()
            errorTextView?.text = "Please enter contact name".localized()
            errorTextView?.isVisible = true
            isDataValid = false
            return
        }
        if (address.isNullOrBlank()) {
            addressTextInput?.errorShake()
            errorTextView?.text = "Please enter contact address".localized()
            errorTextView?.isVisible = true
            isDataValid = false
            return
        }
        if (type == ContactType.Other) {
            if (imageUrl.isNullOrBlank()) {
                imageContainer?.errorShake()
                errorTextView?.text = "Please select contact icon".localized()
                errorTextView?.isVisible = true
                isDataValid = false
                return
            }
            if (link.isNullOrBlank()) {
                externalLinkTextInput?.errorShake()
                errorTextView?.text = "Please enter contact external link".localized()
                errorTextView?.isVisible = true
                isDataValid = false
                return
            }
        }
        errorTextView?.text = ""
        errorTextView?.isVisible = false
        val contact = ContactDto(
            id = dtoToEdit?.id,
            name = name,
            address = address,
            imageUrl = imageUrl,
            link = link,
            type = type.dto(),
        )
        viewModel.editItem(contact)
        isDataValid = true
    }

    private var isDataValid = false

    private fun TextInput?.validateAndGetText(): String {
        val text = this?.text ?: ""
        if (text.isBlank()) {
            isDataValid = false
            this?.addErrorStyle()
        } else {
            this?.resetStyle()
        }
        return text
    }


    private fun View.addErrorStyle() {
        removeRuleSet(textInputStyle)
        addRuleSet(textInputErrorStyle)
    }

    private fun View.resetStyle() {
        removeRuleSet(textInputErrorStyle)
        addRuleSet(textInputStyle)
    }

    fun add() {
        dtoToEdit = null
        upsertDialog()
    }

    fun edit(dto: ContactDto) {
        dtoToEdit = dto
        upsertDialog()
    }

    private val textInputErrorStyle = classRuleSet {
        padding = 4.px
        fontSize = 14.px
        padding = "6px 12px".dimen()
        border = "1px solid ${AppColors.redLight}"
        borderRadius = 4.px
    }


}
